import { useState } from 'react';

import { ColumnConfigurationRenderAs } from '@april9au/stack9-sdk';
import * as ui from '@april9au/stack9-ui';

import { BaseOptionSetDrawer } from '../../components/BaseOptionSetDrawer/BaseOptionSetDrawer';
import { ListTable } from '../../components/ListTable/ListTable';

type Props = {
  id: number;
};

const Button = ui.S9Button.default;
const { Space, useRefreshList } = ui;

const BaseOptionSetDetail = ({ id }: Props) => {
  const [isOpen, setIsOpen] = useState(false);
  const refresh = useRefreshList();
  return (
    <ListTable
      queryVars={{
        baseRequirement: id,
      }}
      queryName="getbaseoptionsetbybaserequirement"
      title="Base option set"
      columns={[
        {
          label: 'Sequence',
          field: 'sequence',
          renderAs: ColumnConfigurationRenderAs.Text,
          value: '{{sequence}}',
        },
        {
          label: 'Option',
          field: 'option',
          renderAs: ColumnConfigurationRenderAs.CustomComponent,
          options: {
            customComponentName: 'BaseOptionSetAction',
          },
          value: '{{option}}',
        },
        {
          label: 'Is correct',
          field: 'is_correct',
          renderAs: ColumnConfigurationRenderAs.EnumTags,
          value: '{{is_correct}}',
          options: {
            enumColor: {
              Yes: 'green',
              No: 'red',
            },
          },
        },
        {
          label: 'Negative response',
          field: 'negative_response',
          renderAs: ColumnConfigurationRenderAs.Text,
          value: '{{negative_response}}',
        },
        {
          label: 'Is active',
          field: 'is_active',
          renderAs: ColumnConfigurationRenderAs.EnumTags,
          value: '{{is_active}}',
          options: {
            enumColor: {
              Yes: 'green',
              No: 'red',
            },
          },
        },
      ]}
    >
      <div
        style={{ display: 'flex', justifyContent: 'end', marginBottom: '15px' }}
      >
        <BaseOptionSetDrawer
          initialValues={{ base_requirement_id: id }}
          open={isOpen}
          onClose={() => {
            setIsOpen(false);
            refresh();
          }}
        />
        <Space>
          <Button
            label="Create"
            onClick={() => setIsOpen(true)}
            type="primary"
          />
        </Space>
      </div>
    </ListTable>
  );
};

export default BaseOptionSetDetail;
